// deploy-pipelines-run-overrides (Wave 4, AC-14/AC-26) — the `Reason` -> copy map for a
// `PipelineBranchListDto` whose `Available` is false. Mirrors the `resolveRunLogMessage`
// precedent (Wave 3, OQ-4): a closed set on the wire is not closed in practice, so an
// unrecognised `Reason` still gets a defined sentence, never a blank fallback.
//
// Neither state is an error — `Available: false` is a 200 (spec: "this is a 200, not an
// error"). The run dialog falls back to a free-text branch field in both cases (AC-26); this
// message is the accompanying explanation, not a blocker.
export const BranchListUnavailableReason = {
	ListingUnavailable: 'ListingUnavailable',
	NoBuildSource: 'NoBuildSource'
};

export const BRANCH_LIST_UNAVAILABLE_MESSAGE = {
	[BranchListUnavailableReason.ListingUnavailable]:
		"This token can read the repository but can't list its branches — enter the branch name manually.",
	[BranchListUnavailableReason.NoBuildSource]:
		'This pipeline has no build source yet — enter the branch name manually.'
};

// AC-14's explicit requirement, mirrored on the FE: an UNRECOGNISED `Reason` must fall back to a
// defined message, never render nothing.
export const GENERIC_BRANCH_LIST_UNAVAILABLE_MESSAGE =
	'The branch list is unavailable right now — enter the branch name manually.';

/**
 * @param {{Available: boolean, Reason: string|null}|null|undefined} branchListResult
 * @returns {string|null}  null when `Available` (or nothing has been fetched yet) — there is
 *                          nothing to explain; otherwise a defined sentence, never blank.
 */
export const resolveBranchListUnavailableMessage = (branchListResult) => {
	if (!branchListResult || branchListResult.Available) {
		return null;
	}

	// An OWN-property check, not `MAP[reason] ?? fallback` — see resolveRunLogMessage's identical
	// guard against a Reason of 'toString'/'constructor' resolving up the prototype chain to a
	// function, which `??` would never catch.
	return Object.prototype.hasOwnProperty.call(BRANCH_LIST_UNAVAILABLE_MESSAGE, branchListResult.Reason)
		? BRANCH_LIST_UNAVAILABLE_MESSAGE[branchListResult.Reason]
		: GENERIC_BRANCH_LIST_UNAVAILABLE_MESSAGE;
};

export default resolveBranchListUnavailableMessage;
